<!--
 * @Author: lwk
 * @Date: 2024-01-24 14:03:22
 * @LastEditors: lwk
 * @LastEditTime: 2024-02-27 16:39:50
 * @Description: 请填写简介
-->
<template>
  <div>
    <div class="timeRadio">
      <el-select
        v-model="excllentValue"
        placeholder="请选择"
        size="mini"
        style="width: 120px;display: flex;flex-direction: column;"
        @change="changeDate"
        :popper-append-to-body="false"
      >
        <el-option
          v-for="item in excellentOptions"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <el-radio-group v-model="excellentRadioVal" size="mini" @input="changeDate" style="margin-left: 6px;">
        <el-radio-button label="1">本月</el-radio-button>
        <el-radio-button label="2">本季度</el-radio-button>
        <el-radio-button label="3">本年</el-radio-button>
      </el-radio-group>
    </div>
    <div id="echartsId"></div>
  </div>
</template>

<script>
import * as echarts from "echarts";
import moment from "moment";
import { getSubentry,getSubentryData } from "@/api/morningMeet";

export default {
  name: "ManagerLike",
  data() {
    return {
      radioTime: "month",
      startTime: "",
      endTime: "",
      sourceData: [],
      myChart: "",
      excellentOptions: [],
      excllentValue: "",
      excellentRadioVal:"1"
    };
  },
  mounted() {
    this.getSubentryList()
    setTimeout(() => {
      this.initEcharts();
      this.changeDate();
    }, 500);
  },
  methods: {
    initEcharts() {
      var chartDom = document.getElementById("echartsId");
      var chartsOption = {
        title: {
          text: "分项统计"
        },
        legend: {
          // right: 100,
          // top: 20,
          textStyle: {
            align: "center" // 水平对齐方式为居中
          }
        },
        tooltip: {},
        grid: {
          left: "3%",
          right: "4%",
          bottom: "1%",
          containLabel: true
        },
        xAxis: [
          {
            type: "category",
            data: this.xAxisList,
            axisTick: {
              alignWithLabel: true
            },
            axisLabel: {
              rotate: 20
            }
          }
        ],
        yAxis: { name: "（得分）" },
        // Declare several bar series, each will be mapped
        // to a column of dataset.source by default.
        series: [
          {
            type: "bar",
            data: this.chartsData,
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: "#83bff6" },
                { offset: 0.5, color: "#188df0" },
                { offset: 1, color: "#188df0" }
              ])
            }
          }
        ]
      };
      this.myChart = echarts.init(chartDom);
      chartsOption && this.myChart.setOption(chartsOption);
    },
    async changeDate() {
      this.getSubentryDataCharts();
    },
    async getSubentryList() {
      const {code ,data} = await getSubentry()
      if(code != 0) return
      this.excellentOptions = data.map(item => ({label:item,value:item}))
      this.excllentValue = this.excellentOptions[0].value
     },
     async getSubentryDataCharts() {
      const params = {
        deptName:this.excllentValue,
        dateType:this.excellentRadioVal
      }
      const {code,data} = await getSubentryData(params)
      if(code != 0) return
      this.xAxisList = data.map(item => (item.scoreItem))
      this.chartsData = data.map(item => (item.score))
      this.myChart.setOption({
        xAxis: [{ data: this.xAxisList }],
        series: [{ data: this.chartsData }]
      });
    }
  }
};
</script>

<style>
#echartsId {
  width: 100%;
  height: 260px;
}
.timeRadio {
  position: absolute;
  margin-top: 15px;
  z-index: 999;
  right: 6%;
}
</style>



// WEBPACK FOOTER //
// src/components/MorningMeeting/ExcellentStatistical.vue